/*
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */
import HangUpModule from './hangUp';
import DividerModule from './dividerItem';

const SystemModules: any = {
  HangUpModule,
  DividerModule,
};

export default SystemModules;
